import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { LoginService } from 'app/pages/login/login.service';
import { ThemeEnum } from '../themes/theme.enum';

@Injectable()
export class ThemesServiceV2 {

    // private fields
    private _employeeApiUrl = '/organization/employees/';
    private _themeSessionVariableName = 'themeV2';

    constructor(@Inject(DOCUMENT) private document: Document,
        private http: ApplicationHttpClient,
        private loginService: LoginService) { }

    /**
     * get current theme name, if no theme stored in session set current theme to default (dark)
     * @returns theme name
     */
    getTheme(): ThemeEnum {
        const currentThemeName = window.sessionStorage.getItem(this._themeSessionVariableName);

        return currentThemeName === ThemeEnum.DarkTheme ? ThemeEnum.DarkTheme : ThemeEnum.LightTheme;
    }

    /**
     * toggel theme
     */
    toggleTheme(): void {
        const currentThemeName = window.sessionStorage.getItem(this._themeSessionVariableName);
        const themeName = currentThemeName === ThemeEnum.LightTheme ? ThemeEnum.DarkTheme : ThemeEnum.LightTheme;

        this.setTheme(themeName);
        this.updateEmployeePreferedUITheme(themeName);
    }

    /**
     * init theme by default it is dark theme
     */
    initTheme(): void {
        const isEmployeeLoggedIn = this.loginService.isLoggedIn();
        if (isEmployeeLoggedIn) {
            let currentThemeName = window.sessionStorage.getItem(this._themeSessionVariableName);
            let theme = null;

            if (currentThemeName) {
                theme = currentThemeName === ThemeEnum.LightTheme ? ThemeEnum.LightTheme : ThemeEnum.DarkTheme;
            }

            if (!theme) {
                this.getEmployeePreferedTheme()
                    .then((preferedUITheme: ThemeEnum) => {
                        this.setTheme(preferedUITheme);
                    })
            } else {
                this.setTheme(theme);
            }
        } else {
            this.document.body.className = ThemeEnum.DarkTheme;
        }
    }

    /**
     * reset prefered theme (used when switch dealer)
     */
    resetTheme(): void {
        window.sessionStorage.removeItem(this._themeSessionVariableName);

        this.getEmployeePreferedTheme()
            .then((preferedUITheme: ThemeEnum) => {
                this.setTheme(preferedUITheme);
            })
    }

    /**
    * set new theme (dark / light)
    * @param themeName theme name
    */
    private setTheme(themeName: ThemeEnum): void {
        if (!themeName) {
            themeName = ThemeEnum.DarkTheme;
        }

        window.sessionStorage.setItem(this._themeSessionVariableName, themeName);
        this.document.body.className = themeName;
    }

    /**
     * get employee prefered theme from api
     */
    private getEmployeePreferedTheme(): Promise<any> {
        const promise = new Promise((resolve, reject) => {
            this.http.get(this._employeeApiUrl + 'GetEmployeePreferedUIThemeById').toPromise()
                .then((response: string) => {
                    resolve(response);
                }, (error) => {
                    resolve(null);
                });
        });

        return promise;
    }

    /**
     * save prefered ui theme
     * @param theme prefered ui theme
     */
    private updateEmployeePreferedUITheme(theme: ThemeEnum): void {
        this.http.post(this._employeeApiUrl + 'UpdateEmployeePreferedUITheme', {
            themeName: theme
        }).subscribe();
    }

}
